(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brw-home-hero"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('brw-stock-hero')) {
  customElements.define('brw-stock-hero', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.index = 0;
      this.verified = true;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
      this.hovering = false;
      this.track = this.querySelector('[data-hero-track]');
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.on('click', event => {
        if (event.target.closest('[data-hero-next]')) this.manual(1);
        if (event.target.closest('[data-hero-previous]')) this.manual(-1);
        if (event.target.closest('[data-hero-toggle]')) {
          this.paused = !this.paused;
          this.updateControls();
          this.schedule();
        }
      });
      this.on('submit', () => { this.paused = true; this.updateControls(); this.schedule(); });
      this.on('mouseenter', () => { this.hovering = true; this.schedule(); });
      this.on('mouseleave', () => { this.hovering = false; this.schedule(); });
      this.on('focusin', event => {
        if (!this.contains(event.relatedTarget) && !event.target.closest('[data-hero-toggle]')) {
          this.paused = true;
          this.updateControls();
          this.schedule();
        }
      });
      this.on('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.manual(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      document.addEventListener('visibilitychange', () => {
        this.schedule();
        if (!document.hidden) this.refresh();
      }, {signal: this.abort.signal});
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.updateControls();
        this.schedule();
      }, {signal: this.abort.signal});
      this.updateControls();
      this.schedule();
      this.stockTimer = setInterval(() => { if (!document.hidden) this.refresh(); }, 60000);
    }
    disconnectedCallback() {
      this.abort.abort();
      clearTimeout(this.timer);
      clearInterval(this.stockTimer);
      clearTimeout(this.transitionTimer);
      this.request?.abort();
    }
    on(name, callback) {
      this.addEventListener(name, callback, {signal: this.abort.signal});
    }
    updateControls() {
      const count = this.slides.length;
      this.hidden = count === 0 || !this.verified;
      this.querySelector('[data-hero-controls]').hidden = count < 2;
      this.querySelector('[data-hero-counter]').textContent = this.dataset.counter.replace('[current]', count ? this.index + 1 : 0).replace('[total]', count);
      this.querySelector('[data-hero-toggle]').textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.querySelector('[data-hero-toggle]').setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
      this.querySelector('[data-hero-toggle]').setAttribute('data-paused', String(this.paused));
      this.track.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      const nextImage = this.slides[(this.index + 1) % count]?.querySelector('img');
      if (nextImage) nextImage.loading = 'eager';
    }
    finishTransition() {
      clearTimeout(this.transitionTimer);
      this.slides.forEach((slide, i) => {
        slide.classList.remove('brw-hero-entering', 'brw-hero-leaving');
        slide.hidden = i !== this.index;
        slide.inert = i !== this.index;
        slide.setAttribute('aria-hidden', String(i !== this.index));
      });
    }
    show(index) {
      if (!this.slides.length) return;
      this.finishTransition();
      const previousIndex = this.index;
      const previous = this.slides[previousIndex];
      this.index = (index + this.slides.length) % this.slides.length;
      const incoming = this.slides[this.index];
      const img = incoming.querySelector('img');
      if (img) img.loading = 'eager';
      incoming.hidden = false;
      incoming.inert = false;
      incoming.setAttribute('aria-hidden', 'false');
      if (previous && previousIndex !== this.index && !this.motion.matches) {
        previous.inert = true;
        previous.setAttribute('aria-hidden', 'true');
        previous.classList.add('brw-hero-leaving');
        incoming.classList.add('brw-hero-entering');
        this.transitionTimer = setTimeout(() => this.finishTransition(), 800);
      } else {
        this.finishTransition();
      }
      this.updateControls();
    }
    manual(direction) {
      this.paused = true;
      this.show(this.index + direction);
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.verified || this.paused || this.hovering || document.hidden || this.slides.length < 2) return;
      this.timer = setTimeout(() => {
        this.show(this.index + 1);
        this.schedule();
      }, Number(this.dataset.interval) || 6000);
    }
    async refresh() {
      if (this.refreshing || !this.isConnected || this.querySelector('[type="submit"][aria-disabled="true"]')) return;
      this.refreshing = true;
      this.request = new AbortController();
      const timeout = setTimeout(() => this.request.abort(), 10000);
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        url.searchParams.set('_brw_stock', Date.now().toString());
        const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store', signal: this.request.signal});
        if (!response.ok) throw new Error('Inventory unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = html.querySelector('brw-stock-hero');
        if (!fresh || fresh.dataset.sectionId !== this.dataset.sectionId) throw new Error('Inventory unavailable');
        if (!this.isConnected) return;
        this.verified = true;
        if (this.querySelector('[type="submit"][aria-disabled="true"]')) return;
        const current = this.slides[this.index]?.dataset.variantId;
        const freshSlides = Array.from(fresh.querySelectorAll('[data-hero-slide]'));
        const freshKeys = freshSlides.map(slide => slide.dataset.variantId + slide.textContent.trim()).join('|');
        const oldKeys = this.slides.map(slide => slide.dataset.variantId + slide.textContent.trim()).join('|');
        if (freshKeys !== oldKeys || this.hidden) {
          this.track.replaceChildren(...freshSlides);
          this.slides = freshSlides;
          this.show(Math.max(0, this.slides.findIndex(slide => slide.dataset.variantId === current)));
          this.updateControls();
        }
        this.schedule();
      } catch (error) {
        if (this.isConnected) {
          clearTimeout(this.timer);
          this.verified = false;
          this.hidden = true;
        }
      } finally {
        clearTimeout(timeout);
        this.refreshing = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brw-main-article"]) return;
  try {
    
if (!customElements.get('brw-journal-article')) {
  customElements.define('brw-journal-article', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const headings = [...this.querySelectorAll('[data-brw-article-body] h2')];
      const toc = this.querySelector('[data-brw-toc]');
      const list = this.querySelector('[data-brw-toc-list]');
      if (headings.length > 1 && toc && list) {
        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = `brw-story-${this.dataset.articleId}-${index + 1}`;
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = `#${heading.id}`;
          link.textContent = heading.textContent;
          item.append(link);
          list.append(item);
        });
        toc.hidden = false;
        toc.open = window.matchMedia('(min-width: 990px)').matches;
      }
      const button = this.querySelector('[data-brw-copy-link]');
      const status = this.querySelector('[data-brw-copy-status]');
      if (button && navigator.clipboard) {
        button.hidden = false;
        button.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(location.origin + location.pathname);
            status.textContent = status.dataset.success;
          } catch (_) { status.textContent = status.dataset.error; }
        });
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brw-scent-quiz"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brw-scent-quiz')) {
  customElements.define('brw-scent-quiz', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.step = 0;
      this.form = this.querySelector('[data-quiz-form]');
      this.steps = [...this.querySelectorAll('[data-step]')];
      this.results = this.querySelector('[data-results]');
      this.intro = this.querySelector('[data-intro]');
      this.next = this.querySelector('[data-next-button]');
      this.back = this.querySelector('[data-back]');
      this.products = [...this.querySelectorAll('[data-scent-product]')];
      this.querySelector('[data-start]').hidden = false;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-start]')) { this.intro.hidden = true; this.form.hidden = false; this.showStep(); }
        if (event.target.closest('[data-back]')) { this.step = Math.max(0, this.step - 1); this.showStep(); }
        if (event.target.closest('[data-edit]')) { this.results.hidden = true; this.form.hidden = false; this.step = 0; this.showStep(); }
        if (event.target.closest('[data-retake]')) { this.form.reset(); this.results.hidden = true; this.form.hidden = false; this.step = 0; this.showStep(); }
      });
      this.addEventListener('submit', event => {
        const form = event.target.closest('[data-quiz-add]');
        if (!form) return;
        event.preventDefault();
        this.addMatch(form);
      });
      this.addEventListener('change', event => {
        if (!event.target.matches('.brw-sq-variant')) return;
        const option = event.target.selectedOptions[0];
        event.target.closest('.brw-sq-product').querySelector('.brw-sq-price').textContent = option.dataset.price;
      });
      this.form.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('input[type="checkbox"]') && input.checked) {
          for (const sibling of this.form.querySelectorAll(`input[name="${input.name}"]`)) {
            if (sibling !== input && (input.value === 'any' || sibling.value === 'any')) sibling.checked = false;
          }
        }
        this.updateNext();
      });
      this.form.addEventListener('submit', event => {
        event.preventDefault();
        if (!this.steps[this.step].querySelector('input:checked')) return;
        if (this.step < this.steps.length - 1) { this.step++; this.showStep(); } else { this.showResults(); }
      });
    }
    async addMatch(form) {
      if (this.cartPending) return;
      this.cartPending = true;
      const button = form.querySelector('button[type="submit"]');
      const label = button.textContent;
      const status = form.querySelector('[data-add-status]');
      this.querySelectorAll('[data-quiz-add] button').forEach(item => { item.disabled = true; });
      button.textContent = this.dataset.adding;
      button.setAttribute('aria-busy','true');
      status.textContent = '';
      let added = false;
      try {
        const data = new FormData(form);
        data.append('sections', `cart-icon-bubble,${this.dataset.sectionId}`);
        data.append('sections_url', window.location.pathname);
        const response = await fetch(this.dataset.addUrl, {method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        const result = await response.json();
        if (!response.ok || result.status) {
          status.textContent = typeof result.description === 'string' ? result.description : this.dataset.addError;
          return;
        }
        added = true;
        const message = this.dataset.added.replace('[product]', form.dataset.productTitle);
        status.textContent = message;
        this.querySelector('[data-cart-feedback]').hidden = false;
        this.querySelector('[data-cart-status]').textContent = message;
        const iconHTML = result.sections?.['cart-icon-bubble'];
        if (iconHTML) {
          const icon = new DOMParser().parseFromString(iconHTML,'text/html').querySelector('.shopify-section');
          const target = document.getElementById('cart-icon-bubble');
          if (icon && target) target.innerHTML = icon.innerHTML;
        }
        const sectionHTML = result.sections?.[this.dataset.sectionId];
        if (sectionHTML) {
          const state = new DOMParser().parseFromString(sectionHTML,'text/html').querySelector('[data-bundle-cart]');
          if (state) {
            const cartState = JSON.parse(state.textContent);
            this.showBundle(form.dataset.bundleCategory, cartState);
            this.showPairings(form, cartState);
          }
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'brw-scent-quiz'});
      } catch (error) {
        status.textContent = added ? this.dataset.added.replace('[product]', form.dataset.productTitle) : this.dataset.addError;
      } finally {
        this.cartPending = false;
        this.querySelectorAll('[data-quiz-add] button').forEach(item => { item.disabled = false; });
        button.textContent = label;
        button.removeAttribute('aria-busy');
      }
    }
    showPairings(form, state) {
      const addedId = form.closest('[data-quiz-product-id]').dataset.quizProductId;
      const addedProduct = this.products.find(product => product.dataset.productId === addedId);
      if (addedProduct && ['candle','melt'].includes(addedProduct.dataset.format)) this.pairingSource = addedProduct;
      const source = this.pairingSource;
      const panel = this.querySelector('[data-pairings-panel]');
      if (!source) { panel.hidden = true; return; }
      const scentName = product => product.dataset.scentTitle.toLowerCase().split(/[–—]/)[0].replace(/forrest/g,'forest').replace(/apples/g,'apple').replace(/room|fabric|sprays?|wax|melts?|candles?|coco|soy|handcrafted|handmade|soap|scented|scent|\band\b|\bwith\b/g,' ').replace(/[^a-z0-9]+/g,' ').trim();
      const titleWords = new Set(scentName(source).split(' ').filter(word => word.length > 2));
      const vocabulary = ['vanilla','oak','cedar','pine','fir','wood','sandalwood','smoke','leather','suede','patchouli','moss','sage','lavender','mint','eucalyptus','tea tree','lemon','orange','citrus','grapefruit','apple','raspberry','berry','pear','peach','coconut','pumpkin','cinnamon','clove','ginger','nutmeg','cardamom','chai','coffee','sugar','caramel','butter','cream','amber','musk','floral','rose','jasmine','green','herbal'];
      const sourceNotes = vocabulary.filter(note => source.dataset.noteText.toLowerCase().includes(note));
      const seen = new Set([...state.ids.map(String), ...[...this.querySelectorAll('[data-result-cards] [data-quiz-product-id]')].map(product => product.dataset.quizProductId)]);
      const cards = [];
      for (const format of ['spray','soap']) {
        const candidates = this.products.filter(product => product.dataset.format === format && !seen.has(product.dataset.productId)).map((product,index) => {
          const exact = scentName(product) === scentName(source);
          const titleOverlap = scentName(product).split(' ').filter(word => titleWords.has(word)).length;
          const noteOverlap = sourceNotes.filter(note => product.dataset.noteText.toLowerCase().includes(note)).length;
          const familyMatch = product.dataset.family === source.dataset.family;
          return {product,index,exact,relevant:exact || familyMatch || titleOverlap > 1 || noteOverlap > 1,score:(exact ? 1000 : 0) + titleOverlap * 12 + noteOverlap * 4 + (familyMatch ? 30 : 0)};
        }).filter(match => match.relevant).sort((a,b) => b.score - a.score || a.index - b.index);
        if (!candidates.length) continue;
        const match = candidates[0];
        seen.add(match.product.dataset.productId);
        const card = match.product.content.cloneNode(true);
        card.querySelector('.brw-sq-kicker').textContent = match.exact ? this.dataset.sameScent : this.dataset.relatedScent;
        cards.push(card);
      }
      this.querySelector('[data-pairings-cards]').replaceChildren(...cards);
      panel.hidden = cards.length === 0;
      if (cards.length) panel.scrollIntoView({block:'start',behavior:'instant'});
    }
    showBundle(category, state) {
      const panel = this.querySelector('[data-bundle-panel]');
      const copy = JSON.parse(this.querySelector('[data-bundle-copy]').textContent);
      if (!copy[category]) { panel.hidden = true; return; }
      const count = state.counts[category] || 0;
      const tiers = {candle:[2,4],soap:[3,6,10],spray:[3]}[category];
      const index = tiers.findIndex(tier => count < tier);
      const message = copy[category][index === -1 ? tiers.length : index].replace('[count]', count).replace('[remaining]', index === -1 ? 0 : tiers[index] - count);
      this.querySelector('[data-bundle-message]').textContent = message;
      const seen = new Set([...state.ids.map(String), ...[...this.querySelectorAll('[data-result-cards] [data-quiz-product-id]')].map(product => product.dataset.quizProductId)]);
      const selected = [...this.form.querySelectorAll('input[name="family"]:checked')].map(input => input.value);
      const candidates = this.products.filter(product => product.dataset.bundleCategory === category).sort((a,b) => Number(selected.includes(b.dataset.family)) - Number(selected.includes(a.dataset.family)));
      const suggestions = [];
      for (const product of candidates) {
        if (seen.has(product.dataset.productId)) continue;
        seen.add(product.dataset.productId);
        suggestions.push(product.content.cloneNode(true));
        if (suggestions.length === 2) break;
      }
      this.querySelector('[data-bundle-cards]').replaceChildren(...suggestions);
      panel.hidden = false;
      panel.scrollIntoView({block:'start',behavior:'instant'});
    }
    updateNext() {
      const selected = this.steps[this.step].querySelector('input:checked');
      this.next.disabled = !selected;
      this.next.firstChild.textContent = (this.step === this.steps.length - 1 ? this.dataset.finish : this.dataset.next) + ' ';
    }
    showStep() {
      this.steps.forEach((step, index) => { step.hidden = index !== this.step; });
      this.back.disabled = this.step === 0;
      this.querySelector('[data-progress-label]').textContent = this.dataset.stepLabel.replace('[current]', this.step + 1).replace('[total]', this.steps.length);
      this.querySelector('[data-progress-track] i').style.width = `${(this.step + 1) / this.steps.length * 100}%`;
      this.updateNext();
      this.steps[this.step].querySelector('legend').focus({preventScroll:true});
      this.form.scrollIntoView({block:'start', behavior:'instant'});
    }
    showResults() {
      this.querySelector('[data-bundle-panel]').hidden = true;
      this.querySelector('[data-pairings-panel]').hidden = true;
      this.pairingSource = null;
      const data = new FormData(this.form);
      const answers = Object.fromEntries(['family','notes','format'].map(name => [name, data.getAll(name)]));
      const noteTerms = {vanilla:['vanilla','cream','sugar','caramel','butter'],citrus:['lemon','orange','grapefruit','apple','berry','pear'],wood:['cedar','oak','fir','pine','wood','smoke','incense','patchouli'],spice:['cinnamon','clove','ginger','nutmeg','spice','cardamom'],herbal:['lavender','sage','eucalyptus','mint','green','moss']};
      const terms = [...new Set(answers.notes.flatMap(note => noteTerms[note] || []))];
      const candidates = this.products.filter(product => answers.family.includes(product.dataset.family) && (answers.format.includes('any') || answers.format.includes(product.dataset.format))).map((product,index) => ({product,index,score:terms.reduce((sum,term) => sum + (product.dataset.noteText.toLowerCase().includes(term) ? 1 : 0),0)}));
      const matches = [];
      const seen = new Set();
      const families = new Set();
      const formats = new Set();
      const limit = answers.family.length > 1 || answers.format.length > 1 || answers.notes.length > 1 ? 6 : 3;
      while (matches.length < limit) {
        const remaining = candidates.filter(match => !seen.has(match.product.dataset.handle));
        const rank = match => match.score + (families.has(match.product.dataset.family) ? 0 : 20) + (formats.has(match.product.dataset.format) ? 0 : 10);
        remaining.sort((a,b) => rank(b) - rank(a) || a.index - b.index);
        if (!remaining.length) break;
        const chosen = remaining[0];
        matches.push(chosen);
        seen.add(chosen.product.dataset.handle);
        families.add(chosen.product.dataset.family);
        formats.add(chosen.product.dataset.format);
      }
      this.querySelector('[data-result-cards]').replaceChildren(...matches.map(match => match.product.content.cloneNode(true)));
      const summary = this.querySelector('[data-choice-summary]');
      summary.replaceChildren();
      for (const name of ['family','notes','format']) {
        for (const input of this.form.querySelectorAll(`input[name="${name}"]:checked`)) {
          const item = document.createElement('li');
          item.textContent = input.closest('label').querySelector('strong').textContent;
          summary.append(item);
        }
      }
      this.querySelector('[data-empty-state]').hidden = matches.length > 0;
      this.querySelector('[data-results-description]').hidden = matches.length === 0;
      this.form.hidden = true;
      this.results.hidden = false;
      this.querySelector('[data-result-count]').textContent = matches.length ? (matches.length === 1 ? this.dataset.countOne : this.dataset.count.replace('[count]', matches.length)) : this.dataset.empty;
      this.querySelector('[data-results-heading]').focus({preventScroll:true});
      this.results.scrollIntoView({block:'start',behavior:'instant'});
      this.dispatchEvent(new CustomEvent('brw:quiz-complete',{bubbles:true,detail:{family:answers.family,format:answers.format,count:matches.length}}));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function attachCheckboxListener() {
  var checkbox = document.getElementById('signup-checkbox-footer');
  var submitButton = document.getElementById('FooterSubscribe');

  if (checkbox && submitButton) {
    checkbox.removeEventListener('change', toggleSubmitButton);
    checkbox.addEventListener('change', toggleSubmitButton);

    submitButton.disabled = !checkbox.checked;
  }
}

function toggleSubmitButton() {
  var submitButton = document.getElementById('FooterSubscribe');
  if (submitButton) {
    submitButton.disabled = !this.checked;
  }
}

document.addEventListener('DOMContentLoaded', attachCheckboxListener);
document.addEventListener('shopify:section:select', attachCheckboxListener);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};

    this.setHeaderHeight();

    const marginDesktopValue = this.getAttribute('data-margin-desktop');
    // Fetch data-margin-desktop and calculate percentage
    this.marginDesktopPercentage = parseFloat(marginDesktopValue) || 2; 
    this.marginDesktopThreshold = this.marginDesktopPercentage*2 / 100; 

    const marginMobileValue = this.getAttribute('data-margin-mobile');
    this.marginMobilePercentage = parseFloat(marginMobileValue) || 2; 
    this.marginMobileThreshold = this.marginMobilePercentage / 300; 

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 250; 
    const viewportWidth = window.innerWidth;
    let resetOffset;

    if (viewportWidth < 990) {
      resetOffset = window.innerHeight * this.marginMobileThreshold;
    } else {
      // Using desktop threshold
      resetOffset = window.innerHeight * this.marginDesktopThreshold;
    }
    
    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom + scrollThreshold)) {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top + resetOffset) {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden');
    this.header.classList.remove('shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}

customElements.define('sticky-header', StickyHeader);

  function initIntersectionObserver() {
  const headers = document.querySelectorAll('.enable-fixed-header-part--true.enable-header-full-width--false');

  if (!headers.length) return; // Ensure there are elements to observe

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        observer.unobserve(entry.target); 
      }
    });
  }, { threshold: 1 });

  headers.forEach(header => {
    observer.observe(header);
  });
}

initIntersectionObserver();

document.addEventListener('shopify:section:load', () => {
  initIntersectionObserver();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner-with-featured-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brw-hero-rotator')) {
  customElements.define('brw-hero-rotator', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const on = (target, event, fn) => target.addEventListener(event, fn, {signal:this.abort.signal});
      this.slides = [...this.querySelectorAll('[data-hero-slide]')];
      this.index = 0;
      this.timer = null;
      this.hovered = false;
      this.focused = false;
      this.inView = true;
      this.editorSelected = false;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.interval = Math.max(5000, Math.min(15000, Number(this.dataset.interval) || 7000));
      this.controls = this.querySelector('.brw-hero-controls');
      this.pauseButton = this.querySelector('[data-hero-pause]');
      const hasVideo = !!this.querySelector('video');
      this.controls.hidden = this.slides.length < 2 && !hasVideo && !this.querySelector(".brw-autumn-atmosphere");
      this.querySelector('[data-hero-total]').textContent = this.slides.length;
      for (const el of this.querySelectorAll('[data-hero-prev],[data-hero-next],.brw-hero-count')) el.hidden = this.slides.length < 2;
      const banner = this.closest('.banner');
      on(this.querySelector('[data-hero-prev]'), 'click', () => this.show(this.index - 1));
      on(this.querySelector('[data-hero-next]'), 'click', () => this.show(this.index + 1));
      on(this.pauseButton, 'click', () => {this.paused = !this.paused; this.sync();});
      on(banner, 'pointerenter', e => {if(e.pointerType === 'mouse'){this.hovered = true;this.sync();}});
      on(banner, 'pointerleave', () => {this.hovered = false;this.sync();});
      on(banner, 'focusin', () => {this.focused = true;this.sync();});
      on(banner, 'focusout', e => {if(!banner.contains(e.relatedTarget)){this.focused = false;this.sync();}});
      on(document, 'visibilitychange', () => this.sync());
      on(this.reduced, 'change', () => {if(this.reduced.matches)this.paused = true;this.sync();});
      on(document, 'shopify:block:select', e => {
        if (!this.closest('.shopify-section').contains(e.target)) return;
        this.editorSelected = true;
        const index = this.slides.findIndex(s => s.dataset.blockId === e.detail.blockId);
        this.show(index < 0 ? 0 : index);
      });
      on(document, 'shopify:block:deselect', e => {if(this.closest('.shopify-section').contains(e.target)){this.editorSelected = false;this.sync();}});
      this.observer = new IntersectionObserver(entries => {this.inView = entries[0].isIntersecting;this.sync();},{threshold:.1});
      this.observer.observe(banner);
      this.sync();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide,i) => {
        slide.classList.toggle('is-active', i === this.index);
        slide.setAttribute('aria-hidden', String(i !== this.index));
        const video = slide.querySelector('video');
        if(video && i !== this.index) {video.pause(); if(video.readyState > 0) video.currentTime = 0;}
      });
      this.querySelector('[data-hero-current]').textContent = this.index + 1;
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      const stopped = this.paused || document.hidden || !this.inView || this.editorSelected;
      const rotateStopped = stopped || this.hovered || this.focused;
      this.setAttribute("data-motion-paused", String(stopped));
      this.pauseButton.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.pauseButton.setAttribute('aria-pressed', String(this.paused));
      this.slides.forEach((slide,i) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if(stopped || i !== this.index) video.pause();
        else {video.muted = true; const play = video.play(); if(play)play.catch(()=>{});}
      });
      if (!rotateStopped && this.slides.length > 1) this.timer = setTimeout(() => this.show(this.index + 1),this.interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
      this.querySelectorAll('video').forEach(v=>v.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
